import { useNavigate } from 'react-router-dom';
import { RootStateOrAny, useSelector } from 'react-redux';
import React, { useContext } from 'react';
import { PermissionsUtil } from '../../../../utils/permissions/permissionsUtil';
import { PERMISSIONS } from '../../../../constants/permissions/Permissions.constants';
import { useListToxicTestQuery } from '../../../../services/formulation/toxicTest/toxicTest.service';
import SettingsContext from '../../../../contexts/settings.context';
import { useGetTermSetQuery } from '../../../../services/i18n/i18n.service';
import { FORMULATION_DEFS } from '../../../../constants/i18n/translations/termSetDefinitions/formulation';
import { skipToken } from '@reduxjs/toolkit/query';

const useToxicTestGrid = () => {
    const navigate = useNavigate();
    const user = useSelector((state: RootStateOrAny) => state.user);

    const { data: toxicTestList, isLoading: isLoadingToxicTest } =
        useListToxicTestQuery();

    const canCreateToxicTest = PermissionsUtil.isPermissionEnabled(
        user.permissions,
        PERMISSIONS.FORMULATION.TOXIC_TEST.CREATE
    );
    const canViewToxicTest = PermissionsUtil.isPermissionEnabled(
        user.permissions,
        PERMISSIONS.FORMULATION.TOXIC_TEST.VIEW
    );

    const { settings } = useContext(SettingsContext);
    const { data: termSet } = useGetTermSetQuery(
        settings?.userSettings
            ? {
                  languageId: settings?.userSettings?.languageId,
                  code: FORMULATION_DEFS.TOXIC_TEST_GRID,
              }
            : skipToken
    );

    const redirectToForm = (row: any) => {
        if (row?.id) {
            navigate(`/formulation/toxicTest/${row.id}`);
        } else {
            navigate('/formulation/toxicTest/new');
        }
    };

    return {
        redirectToForm,
        toxicTestList,
        isLoadingToxicTest,
        canCreateToxicTest,
        canViewToxicTest,
        termSet,
    };
};

export default useToxicTestGrid;
